export default {
  noInternetConnection: 'No Internet Connection',
};
